import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../../constants/api.js";
import Modal from "../../../components/modal/modal.jsx";
import Swal from "sweetalert2";
import "./post-colunista.css";

function PostColunista() {
  const { id_colunista, id_post_colunista } = useParams();
  const navigate = useNavigate();

  const [post, setPost] = useState(null);
  const [open, setOpen] = useState(false);

  const [titulo, setTitulo] = useState("");
  const [texto, setTexto] = useState("");
  const [img, setImg] = useState(null);

  /* ================= BUSCAR POST ================= */
  useEffect(() => {
    async function fetchPost() {
      try {
        const response = await api.get(
          `/admin/colunistas/${id_colunista}/posts/${id_post_colunista}`
        );

        setPost(response.data);
        setTitulo(response.data.titulo);
        setTexto(response.data.texto);
        setImg(response.data.foto);
      } catch (error) {
        console.log(
          error.response?.data?.error || "Erro ao buscar post"
        );
      }
    }

    fetchPost();
  }, [id_colunista, id_post_colunista]);

  /* ================= EDITAR ================= */
  function editar() {
    setOpen(true);
  }

  async function enviarEdit() {
    const formData = new FormData();
    formData.append("titulo", titulo);
    formData.append("texto", texto);

    if (img && typeof img !== "string") {
      formData.append("foto", img);
    }

    const response = await api.put(
      `/admin/colunistas/${id_colunista}/posts/${id_post_colunista}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    setPost(response.data);
    setImg(response.data.foto);
    setOpen(false);
  }

  /* ================= EXCLUIR ================= */
  async function excluir() {
    const result = await Swal.fire({
      title: "Tem certeza?",
      text: "Esse post será excluído permanentemente",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#dc2626",
    });

    if (!result.isConfirmed) return;

    await api.delete(
      `/admin/colunistas/${id_colunista}/posts/${id_post_colunista}`
    );

    Swal.fire({
      icon: "success",
      title: "Post excluído!",
      timer: 1200,
      showConfirmButton: false,
    });

    navigate(`/admin/colunistas/${id_colunista}/posts`);
  }

  if (!post) {
    return <p style={{ padding: "2rem", textAlign: "center" }}>Carregando...</p>;
  }

  return (
    <div className="container-post-colunista">
      <div className="post-colunista-card">

        {post.foto && (
          <img className="imagem-post" src={post.foto} alt={post.titulo} />
        )}

        <h1>{post.titulo}</h1>

        <div className="autor-colunista">
          {post.foto_colunista && (
            <img src={post.foto_colunista} alt={post.nome_colunista} />
          )}
          <span>{post.nome_colunista}</span>
        </div>

        <p>{post.texto}</p>

        {/* ================= BOTÕES ================= */}
        <div className="botoes">
          <button className="btn-editar" onClick={editar}>
            Editar
          </button>

          

          <button className="btn-excluir" onClick={excluir}>
            Excluir
          </button>

          <button className="btn-voltar" onClick={() => navigate(-1)}>
            Voltar
          </button>
        </div>
      </div>

      {/* ================= MODAL ================= */}
      <Modal
        isOpen={open}
        setOpen={setOpen}
        enviar={enviarEdit}
        tipo="post"
        titulo={titulo}
        setTitulo={setTitulo}
        texto={texto}
        setTexto={setTexto}
        img={img}
        setImg={setImg}
        modo="editar"
      />
    </div>
  );
}

export default PostColunista;
